import {Component, inject, signal, DestroyRef} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {RuleCheckerService} from '../../../../services/store/rule-checker.service';
import {ModalComponent} from '../../../../shared/components/modal/modal.component';
import {EmployeePositionId} from '../../../../classes/models/employee/Employee';
import {EmployeeAvailabilityService} from '../../../../services/http/employee/employee-availability.service';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

export interface AvailabilityDeleteWeekData {
  startDate: string;
  employeePositionId?: EmployeePositionId;
}

@Component({
  selector: 'app-availability-delete-week',
  templateUrl: './availability-delete-week.component.html',
  styleUrls: ['./availability-delete-week.component.less'],
  imports: [SHARED_IMPORTS]
})
export class AvailabilityDeleteWeekComponent {
  /** The date starting from which availabilities will be deleted. */
  startDate = signal<string>(undefined);
  /** Identifiers of an employee and position. */
  employeePositionId = signal<EmployeePositionId>(undefined);
  /** `True` if request sending to backend is in progress. */
  loading = signal(false);
  private employeeAvailabilityService = inject(EmployeeAvailabilityService);
  private toastr = inject(ToastrService);
  private ruleCheckerService = inject(RuleCheckerService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }

  static open(modalService: NgbModal, data: AvailabilityDeleteWeekData): NgbModalRef {
    const modalRef = modalService.open(AvailabilityDeleteWeekComponent);
    const instance = modalRef.componentInstance as AvailabilityDeleteWeekComponent;
    instance.startDate.set(data.startDate);
    if (data.employeePositionId !== undefined) {
      instance.employeePositionId.set(data.employeePositionId);
    }
    return modalRef;
  }

  /**
   * Sends request to backend to delete availabilities.
   */
  confirm(modalComponent: ModalComponent): void {
    this.loading.set(true);
    this.employeeAvailabilityService.deleteAvailability(this.employeePositionId(), this.startDate())
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                modalComponent.activeModal.close();
                this.loading.set(false);
                this.toastr.success('Availabilities successfully deleted');
                this.ruleCheckerService.check();
              },
              error: error => {
                this.loading.set(false);
                this.toastr.error(error.error.message);
              }
            });
  }
}